import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
// import { fetchSecurityCheckData } from "../crud/secure.crud";
import {
  createPolicyTemplate as createPolicyTemplateCrud,
  deletePolicyTemplate as deletePolicyTemplateCrud,
  fetchPolicyTemplatesList as fetchPolicyTemplatesListCrud,
  // fetchPolicyTemplate as fetchPolicyTemplateCrud,
  updatePolicyTemplate as updatePolicyTemplateCrud,
} from '../crud/policyTemplates.crud'

const createRequestPolicyTemplatesList = async ({ setError, setLoading, setData, intl, customerId, policyType }) => {
  setLoading(true)
  setError(null)

  try {
    const response = await fetchPolicyTemplatesListCrud({ customerId, policyType })

    setData(response?.data?.templates ?? [])
  } catch (error) {
    console.error(error)
    const generalError = intl.formatMessage({
      id: 'GENERAL.ERROR',
    })
    setError(generalError)
  }

  setLoading(false)
}

const createDeletePolicyTemplate = async ({ setError, setLoading, intl, params }) => {
  setLoading(true)
  setError(null)
  let success = true

  try {
    await deletePolicyTemplateCrud(params)
  } catch (err) {
    success = false
    console.error(err)
    const generalError = intl.formatMessage({
      id: 'GENERAL.ERROR',
    })
    setError(generalError)
  }

  setLoading(false)

  return success
}

const createUpdatePolicyTemplate = async ({ setError, setLoading, intl, params }) => {
  setLoading(true)
  setError(null)

  let response
  try {
    response = await updatePolicyTemplateCrud(params)
  } catch (error) {
    console.error(error)
    const generalError = intl.formatMessage({
      id: 'GENERAL.ERROR',
    })
    setError(generalError)
  }

  setLoading(false)
  return response
}

const createCreatePolicyTemplate = async ({ setError, setLoading, intl, params }) => {
  setLoading(true)
  setError(null)

  let response
  try {
    response = await createPolicyTemplateCrud(params)
  } catch (error) {
    console.error(error)
    const generalError = intl.formatMessage({
      id: 'GENERAL.ERROR',
    })
    setError(generalError)
  }

  setLoading(false)
  return response
}

const usePolicyTemplate = () => {
  const intl = useIntl()

  const customerId = useSelector(({ customers }) => customers?.selectedCustomer?.id)

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [data, setData] = useState(null)

  const requestPolicyTemplatesList = useCallback(
    ({ policyType } = {}) =>
      createRequestPolicyTemplatesList({
        setError,
        setLoading,
        setData,
        intl,
        customerId,
        policyType,
      }),
    [intl, customerId],
  )

  const deletePolicyTemplate = useCallback(
    (params) => createDeletePolicyTemplate({ setError, setLoading, setData, intl, params }),
    [intl],
  )

  const createPolicyTemplate = useCallback(
    (params) => createCreatePolicyTemplate({ setError, setLoading, setData, intl, params }),
    [intl],
  )

  const updatePolicyTemplate = useCallback(
    (params) => createUpdatePolicyTemplate({ setError, setLoading, setData, intl, params }),
    [intl],
  )

  const clearPostureTemplateState = useCallback(() => {
    setLoading(false)
    setError(false)
    setData(null)
  }, [])

  const clearPolicyTemplateError = useCallback(() => setError(null), [])

  return {
    loading,
    error,
    data,
    requestPolicyTemplatesList,
    clearPostureTemplateState,
    deletePolicyTemplate,
    updatePolicyTemplate,
    createPolicyTemplate,
    clearPolicyTemplateError,
  }
}

export default usePolicyTemplate
